import { controls } from "./controls";
import React, { Component } from "react";

const editor = {
  label: "Editor",
  starting: true,
  url: "editor",
  pageLabel: "Editor",
  pageType: "history",
  formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Page Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", star: true, name: "page_name" }),
    ...controls.displayText({ tab: "filter", label: "Page Description", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", star: true, name: "page_display" }),
    ...controls.displayText({ tab: "filter", label: "Modal Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "modal_name" }),
    ...controls.displayText({ tab: "filter", label: "Page Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "select", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Report",
        value: "report"
      },
      {
        label: "Form",
        value: "form"
      },
      {
        label: "Dashboard",
        value: "dashboard"
      }]
    })
  ],
  form: [
    ...controls.displayText({ tab: "create", label: "Page Name", width: "col-sm-2" }),
    ...controls.text({ tab: "create", star: true, name: "page_name" }),

    ...controls.displayText({ tab: "create", label: "Description", width: "col-sm-2" }),
    ...controls.text({ tab: "create", star: true, name: "page_display" }),

    ...controls.displayText({ tab: "filter", label: "Module", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "module", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [
        {
          label: "Auto Gen",
          value: "autogen"
        }, {
          label: "Agri",
          value: "Agri"
        },
        {
          label: "Transactions",
          value: "Transactions"
        },
        {
          label: "Reports",
          value: "Reports"
        },
        {
          label: "Banking",
          value: "Banking"
        },
        {
          label: "Parameters",
          value: "Parameters"
        },
        {
          label: "HO",
          value: "HO"
        }
      ]
    }),


    ...controls.displayText({
      tab: "filter", label: "Sub Module", width: "col-sm-2", parents: [
        {
          name: "module",
          match: "in",
          value: ["HO"]
        }
      ]
    }),
    ...controls.select({
      tab: "filter", name: "submodule", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [

        {
          label: "Shares",
          value: "Shares"
        },
        {
          label: "Payroll",
          value: "Payroll"
        },
        {
          label: "HR",
          value: "HR"
        },
        {
          label: "Stock",
          value: "Stock"
        },
        {
          label: "Investment",
          value: "Investment"
        },
      ],
      parents: [
        {
          name: "module",
          match: "in",
          value: ["HO"]
        }
      ]
    }),
    ...controls.displayText({
      tab: "filter", label: "Sub Module", width: "col-sm-2", parents: [
        {
          name: "module",
          match: "in",
          value: ["Reports"]
        }
      ]
    }),
    ...controls.select({
      tab: "filter", name: "submodule", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [
        {
          label: "Branch",
          value: "Branch"
        },
        {
          label: "Agri",
          value: "Agri"
        },
        {
          label: "Transactions",
          value: "Transactions"
        },
        {
          label: "Dailyreports",
          value: "Dailyreports"
        },
        {
          label: "NonAgri",
          value: "NonAgri"
        },
        {
          label: "Banking",
          value: "Banking"
        },
        {
          label: "Statistics",
          value: "Statistics"
        },
        {
          label: "Transfer",
          value: "Transfer"
        },
        {
          label: "Investment",
          value: "Investment"
        },
        {
          label: "Shares",
          value: "Shares"
        },
        {
          label: "Payroll & HR",
          value: "PayrollnHR"
        },
        {
          label: "Stock",
          value: "Stock"
        }
      ],
      parents: [
        {
          name: "module",
          match: "in",
          value: ["Reports"]
        }
      ]
    }),
    ...controls.displayText({ tab: "create", label: "QUERY Group" }),
    ...controls.oc({ tab: "create", c: "QueryGroup", placeHolder: "Query Group Code", name: "query_group_code", isRequired: false, fastpath: "query_groups" }),
    ...controls.showData({ tab: "create", displaytype: "capital", data: "query_group_display" }),


    ...controls.checkBox({ tab: "create", label: "Force Update", name: "forceupdate", default: false }),


    ...controls.displayText({ tab: "create", label: "CODE", width: "col-sm-12" }),
    ...controls.simpleeditor({ tab: "create", name: "code" }),


  ],
  history: {
    perPage: 10,
    filterable: true,
    reportHeader: "All Pages",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      {
        Header: "Page Code",
        accessor: "page_name",
      },
      {
        Header: "Page Name",
        accessor: "page_display",
      },
      {
        Header: "Module",
        accessor: "module",
      },
      {
        Header: "Sub Module",
        accessor: "submodule",
      },
      {
        Header: "Creation time",
        accessor: "createdat",
      },
      {
        Header: "Query",
        accessor: "OroPage-query_group-query_group_code",
      },
      {
        Header: "Query Group",
        accessor: "OroPage-query_group-query_group_display",
      }
    ]
  }
};

export default editor;

